import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BrokerService } from '../../../broker/broker.service';
import { Router } from '@angular/router';
import { CustomerService } from '../../../customer/customer.service';
import { PolicyService } from '../../../policy/policy.service';
import { VendorService } from '../../../vendor/vendor.service';
import { InspectorService } from '../../../inspector/inspector.service';
import { UserService } from '../../../user/user.service';
import { ProductTypeService } from '../../../product.type/product-type.service';

@Component({
  selector: 'tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit {
  @Input() hide = false;
  @Input()
  active: 'list' | 'archived';
  @Input() type: 'flow' | 'waiting' | 'rejected' | 'accepted' | 'completed' | 'archived';
  nActive: number;
  nArchived: number;
  @Input() title;
  @Input() tabsName: any = { active: 'Active', archived: 'Archived' };
  isVendor = false;

  constructor(
    private brokerService: BrokerService,
    private customerService: CustomerService,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private policyService: PolicyService,
    private vendorService: VendorService,
    private inspectorService: InspectorService,
    private userService: UserService,
    private productTypeService: ProductTypeService,
  ) {}

  async ngOnInit() {
    // if type is not set, then refresh module count
    if (!this.type) {
      await this.refreshCount();
    }

    this.isVendor = (await this.userService.profile()).type === 'Vendor';
  }

  routeTo(type) {
    this.router.navigate([], {
      queryParams: { type: type, page: 1 },
    });
  }

  async refreshCount() {
    let count;
    const serviceMap = {
      Brokers: this.brokerService,
      Customers: this.customerService,
      Policies: this.policyService,
      Vendors: this.vendorService,
      Inspectors: this.inspectorService,
      Admins: this.userService,
      ProductTypes: this.productTypeService,
    };

    try {
      const selectedService = serviceMap[this.joinWords(this.title) ? this.joinWords(this.title) : this.title];
      if (selectedService) {
        count = await selectedService.count();
      }
    } catch (error) {
      console.error('Failed to load count:', error);
    }

    if (count) {
      this.nActive = count.find(c => c.active) ? count.find(c => c.active).count : 0;
      this.nArchived = count.find(c => !c.active) ? count.find(c => !c.active).count : 0;
      this.cdr.markForCheck();
    }
  }

  getClass(tab: string) {
    return {
      active: (this.type ? this.type : this.active) === tab,
    };
  }

  joinWords(str) {
    return str
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word.charAt(0) + word.slice(1);
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join('');
  }
}
